module.exports = __webpack_public_path__ + "img/img_shouji@2x.9ad36d5d.png";